import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToggleService {

  showComponent1 = true;
  showComponent2 = false;
 constructor(){}
  toggleComponents() {
    this.showComponent1 = !this.showComponent1;
    this.showComponent2 = !this.showComponent2;
  }
}
